// extracted by mini-css-extract-plugin
export default {"clearAll":"index_clearAll__nR77h","clearAllText":"index_clearAllText__S48CP"};